<app-logged class="store-list">
  <header class="store-list__header">
    <h2>Informações</h2>
    <div class="store-list__header__actions">
      <button class="btn-primary-light" mat-button routerLink="/dashboard/airports">VOLTAR</button>
      <button
        class="btn-primary-light"
        mat-button
        routerLink="/dashboard/airport/{{ airportID }}/information/new"
      >
        ADICIONAR
      </button>
    </div>
  </header>
  <div class="table-responsive">
    <mat-card class="card-category"><b>Título: </b>{{ titleAirport }}</mat-card>
  </div>
  <div class="table-responsive">
    <table mat-table [dataSource]="airport">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Título Informação</th>
        <td mat-cell *matCellDef="let element">{{ element.title }}</td>
      </ng-container>

      <ng-container matColumnDef="order">
        <th mat-header-cell *matHeaderCellDef>Ordem</th>
        <td mat-cell *matCellDef="let element">{{ element.order }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            matTooltip="Editar"
            matTooltipPosition="left"
            routerLink="/dashboard/airport/{{ airportID }}/information/{{ element.id }}/fields"
          >
            <mat-icon>list</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Editar"
            matTooltipPosition="left"
            routerLink="/dashboard/airport/information/{{ element.id }}/edit"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Remover"
            matTooltipPosition="left"
            (click)="remove(element.id)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headersTable"></tr>
      <tr mat-row *matRowDef="let row; columns: headersTable"></tr>
    </table>
  </div>
</app-logged>
